import React, { useEffect, useState } from 'react'
import sliders from '../../img/slidersSVG.svg'
import codeIcon from '../../img/xmark.svg'
import ViewApiCall from '../../ViewApiCall'
import useStore from '../ProductStore/Store'
import Modal from '../SearchFilters/Modal/ExpandedModal'
import styles from './styles.module.css'

function ExpandedFilters () {
  const {
    isQueryLoading,
    queryStore,
    resetStore,
    name,
    GTIN,
    SKUS,
    brand,
    brandManufacturer,
    taxonomyLevel1,
    taxonomyLevel2,
    taxonomyLevel3,
    primaryCategories,
    rawCategory,
    rentalPrice,
    mostRecentPriceDate,
    description,
    recordRecency,
    featureKeyword,
    requiredFields,
    reviewsRangeQuery,
    domain,
    mostRecentPriceIsSale,
    taxonomy,
    price,
    priceWarranty,
    categoryWildCard,
    color,
    categoriesWithParenthesis,
    featuresWithKey,
    manufacturerNumber
  } = useStore()

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [usedFiltersCount, setUsedFiltersCount] = useState(0)
  const dataType = 'product'

  useEffect(() => {
    const countUsedFilters = () => {
      let count = 0
      if (name) count++
      if (brand) count++
      if (color) count++
      if (GTIN) count++
      if (SKUS) count++
      if (categoryWildCard) count++
      if (brandManufacturer) count++
      if (taxonomyLevel1) count++
      if (taxonomyLevel2) count++
      if (taxonomyLevel3) count++
      if (rawCategory) count++
      if (primaryCategories.length > 0 && !primaryCategories.includes('Any'))
        count++

      if (
        rentalPrice.minValue ||
        rentalPrice.maxValue ||
        rentalPrice.currency
      ) {
        count++
      }

      if (mostRecentPriceDate.startDate || mostRecentPriceDate.endDate) {
        count++
      }
      if (description?.value) {
        count++
      }

      if (reviewsRangeQuery?.min || reviewsRangeQuery?.max) {
        count++
      }

      if (recordRecency?.dateAdded) count++
      if (recordRecency?.dateUpdated) count++

      if (featureKeyword?.key || featureKeyword?.value) {
        count++
      }
      if (requiredFields.length > 0) count++
      if (domain) count++
      if (mostRecentPriceIsSale) count++
      if (taxonomy) count++

      if (price?.minValue || price?.maxValue || price?.currency) {
        count++
      }
      if (priceWarranty) {
        count++
      }
      if (categoriesWithParenthesis) {
        count++
      }
      if (featuresWithKey) {
        count++
      }
      if (manufacturerNumber) count++


      setUsedFiltersCount(count)
    }

    countUsedFilters()
  }, [
    name,
    GTIN,
    SKUS,
    brandManufacturer,
    taxonomyLevel1,
    taxonomyLevel2,
    taxonomyLevel3,
    primaryCategories,
    rawCategory,
    rentalPrice,
    mostRecentPriceDate,
    description,
    recordRecency,
    featureKeyword,
    brand,
    requiredFields,
    reviewsRangeQuery,
    domain,
    mostRecentPriceIsSale,
    taxonomy,
    price,
    priceWarranty,
    categoryWildCard,
    color,
    categoriesWithParenthesis,
    featuresWithKey,
    manufacturerNumber
  ])

  const toggleModal = () => {
    if (!isFiltersDisabled) {
      setIsModalVisible(!isModalVisible)
    }
  }

  const handleClearFilters = () => {
    if (!isClearFiltersDisabled) {
      resetStore()
    }
  }

  const isFiltersDisabled = isQueryLoading
  const isClearFiltersDisabled = !queryStore || isQueryLoading

  return (
    <div className={styles.filterContainer}>
      <div
        onClick={toggleModal}
        className={`${styles.filtersToggleContainerExpandedFilters} ${
          isFiltersDisabled ? styles.disabledFiltersExpandedFilters : ''
        }`}
      >
        <span
          className={`${styles.filterLabel} ${
            isFiltersDisabled ? styles.disabledFiltersExpandedFilters : ''
          }`}
        >
          All filters
        </span>

        <img
          src={sliders}
          alt='sliders'
          className={`${styles.filterIcon} ${
            isFiltersDisabled ? styles.disabledFiltersExpandedFilters : ''
          }`}
        />
        <span
          className={`${styles.filterLabel} ${
            isFiltersDisabled ? styles.disabledFiltersExpandedFilters : ''
          }`}
        >
          ({usedFiltersCount} Used)
        </span>
      </div>

      {isModalVisible && <Modal onClose={() => setIsModalVisible(false)} />}
      <div className={styles.dividerExpandedFilters}></div>

      <div className={styles.clearFiltersContainerExpandedFilters}>
        <span
          onClick={handleClearFilters}
          className={`${styles.clearFiltersSearch} ${
            isClearFiltersDisabled
              ? styles.disabledClearFiltersExpandedFilters
              : ''
          }`}
        >
          Clear filters
        </span>
        <img
          onClick={handleClearFilters}
          src={codeIcon}
          alt='codeIcon'
          className={`${styles.clearFiltersIconExpandedFilters} ${
            isClearFiltersDisabled
              ? styles.disabledClearFiltersExpandedFilters
              : ''
          }`}
        />
      </div>

      <div className={styles.dividerExpandedFilters}></div>

      <ViewApiCall dataType={dataType} />
    </div>
  )
}

export default ExpandedFilters
